module.exports = __webpack_public_path__ + "static/media/yhq.841c5843.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/yhq.png
// module id = 2077
// module chunks = 6